import TextTooltip from "components/shared/TextTooltip";
import type { IBrazilianCompanyIssuerTopLevelFragment } from "lib/fragments/__generated__/BrazilianCompanyIssuerTopLevel.generated";
import notUndefinedOrNull from "lib/utils/notUndefinedOrNull";
import orderBy from "lodash/fp/orderBy";
import classNames from "components/ui/classNames";

interface IPropertyPlantEquipmentListProps {
  propertyPlantEquipment: IBrazilianCompanyIssuerTopLevelFragment["propertyPlantEquipment"];
}

export default function PropertyPlantEquipmentList({ propertyPlantEquipment }: IPropertyPlantEquipmentListProps) {
  return (
    <div className="overflow-hidden rounded bg-white p-2">
      <table className="min-w-full border-collapse border-inherit text-left indent-0 text-sm tracking-wide">
        <thead className="bg-white">
          <tr>
            <th className="px-4 py-3 font-semibold uppercase text-neutral-700">Descrição do Ativo / País</th>
            <th className="px-4 py-3 font-semibold uppercase text-neutral-700">Tipo de Propriedade</th>
          </tr>
        </thead>

        <tbody>
          {orderBy(["type", "country"], ["asc", "asc"], propertyPlantEquipment).map((node, index) => {
            return (
              <tr
                key={`${node.description}/${String(index)}`}
                className={classNames(
                  "group border-t border-neutral-200",
                  "hover:border-t-transparent [&:hover+tr]:border-t-transparent",
                )}
              >
                <td
                  className={classNames(
                    "px-4 py-3 group-hover:bg-neutral-50",
                    "group-hover:first-of-type:rounded-l-md group-hover:last-of-type:rounded-r-md",
                  )}
                >
                  <div>
                    <span className="text-base font-medium text-slate-600">{node.description}</span>
                  </div>

                  <div>
                    <span className="text-sm tracking-wider text-slate-500">
                      {[node.country, node.city].filter(notUndefinedOrNull).join(", ")}
                    </span>
                  </div>
                </td>
                <td
                  className={classNames(
                    "px-4 py-3 group-hover:bg-neutral-50",
                    "group-hover:first-of-type:rounded-l-md group-hover:last-of-type:rounded-r-md",
                  )}
                >
                  {node.typeOfProperty}
                </td>
                <td
                  className={classNames(
                    "px-4 py-3 text-right group-hover:bg-neutral-50",
                    "group-hover:first-of-type:rounded-l-md group-hover:last-of-type:rounded-r-md",
                  )}
                >
                  {node.geographicalCountry && (
                    <div>
                      <TextTooltip
                        key={node.geographicalCountry.isoCode}
                        id={`${node.description}/${node.geographicalCountry.isoCode}`}
                        placement="top"
                        content={node.geographicalCountry.name}
                      >
                        {({ accessibility, bind, ref }) => (
                          <img
                            {...accessibility}
                            {...bind}
                            ref={ref}
                            title={node.geographicalCountry?.name}
                            alt={node.geographicalCountry?.name}
                            src={node.geographicalCountry?.flagSvg.ovalHref}
                            width={24}
                            height={24}
                          />
                        )}
                      </TextTooltip>
                    </div>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
